import React from 'react';
import { ListGroup, ListGroupItem, } from 'reactstrap';
import Request from 'config/Request.js'
import { css } from 'glamor'
import Lib from 'utils/Lib.js'

let loadingStyle = css({
  marginTop: '2rem',
  fontSize: '1.3rem',
  color: '#72747a'
})

export default class TabPurchase extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			isLoading: true,
			data: {
				WarrantyPeriod: "",
				PurchaseOrder: "",
				PurchasePrice: "",
				PurchaseVendor: "",
				PurchasedDate: "",
				PurchaseCurrency: {
					Abbreviations: "",
					Name: ""
				}
			}
		}

		this.onLoad = this.onLoad.bind(this)
		this.onLoadSuccess = this.onLoadSuccess.bind(this)
		this.onLoadFailed = this.onLoadFailed.bind(this)
	}

	onLoad(asset) {
		Request(
			'get',
			'read-asset-purchase',
			{Authorization: "Bearer " + this.props.UserReducer.token},
      {},
      [asset],
      this.onLoadSuccess,
      this.onLoadFailed,
		)
		this.setState({
			isLoading:true
		})
	}

	onLoadSuccess(response) {
		this.setState({
			isLoading:false,
			data: response.data
		})

	}

	onLoadFailed(error) {
		this.setState({
			isLoading:false,
		})
	}

	componentDidMount = () => {
		if(this.props.SelectedItem) {
			this.onLoad(this.props.SelectedItem.Alias)
		}
	}
	
  render() {
		const {data, isLoading} = this.state
		if(isLoading) {
			return (
				<div>
					<div className="list-separator"><div className="item-inner">Purchase Info</div></div>
					<div className="align-center">
						<p {...loadingStyle}>Loading...</p>
					</div>
				</div>
			)
		}

    return (
      <div>
      	<div className="list-separator">
					<div className="item-inner">Purchase Info</div>
				</div>
				<div className="row">
					<div className="col-sm-6">
						<ListGroup>
							<ListGroupItem className="list-border-bottom">
								<strong className="spaceRRR">Purchase Order</strong><span>{Lib.replaceEmpty(data.PurchaseOrder)}</span>
							</ListGroupItem>
							<ListGroupItem className="list-border-bottom">
								<strong className="spaceRRR">Purchase Vendor</strong>
								<span className="break-word" style={{maxWidth:'100%'}}>{Lib.replaceEmpty(data.PurchaseVendor)}</span>
							</ListGroupItem>
						</ListGroup>
					</div>
					<div className="col-sm-6">
						<ListGroup>
							<ListGroupItem className="list-border-bottom">
								<strong className="spaceRRR">Purchase Date</strong>
								<span className="break-word" style={{maxWidth:'100%'}}>{Lib.replaceEmpty(data.PurchasedDate)}</span>
							</ListGroupItem>
							<ListGroupItem className="list-border-bottom">
								<strong className="spaceRRR">Purchase Price</strong>
								<span className="break-word" style={{maxWidth:'100%'}}>{`${data.PurchasePrice.toFixed(2)} (${ Lib.getNested(data, 'PurchaseCurrency.Abbreviations', 'Currency not set')})`}</span>
							</ListGroupItem>
						</ListGroup>
					</div>
				</div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/Tab/TabPurchase.js